import { CLICK, component, componentWithVariants, demoFile, POPUP, story, variant } from 'system/demo';

import { AllCommentsScreen, MostPopularFeature, MostPopularLabel, ViewAllButton } from '../most-popular';

demoFile('feature/question/most-popular', {
    designUrl:
        'https://www.figma.com/design/Jt0Nc37N6PP5bpoSDOhxGU/Ask-Me-Anything---Topic-of-the-Moment---Testing?node-id=1894-20145&p=f&m=dev',
});

component('MostPopularLabel', MostPopularLabel);

const tenComments = [
    { key: '1', from: 'a', text: 'Comment 1', time: 0 },
    { key: '2', from: 'b', text: 'Comment 2', time: 1 },
    { key: '3', from: 'c', text: 'Comment 3', time: 2 },
    { key: '4', from: 'a', text: 'Comment 4', time: 4 },
    { key: '5', from: 'e', text: 'Comment 5', time: 5 },
    { key: '6', from: 'f', text: 'Comment 6', time: 6 },
    { key: '7', from: 'g', text: 'Comment 7', time: 7 },
    { key: '8', from: 'h', text: 'Comment 8', time: 8 },
    { key: '9', from: 'i', text: 'Comment 9', time: 9 },
    { key: '10', from: 'j', text: 'Comment 10', time: 10 },
];

componentWithVariants('ViewAllButton', ViewAllButton, {}, [
    variant(
        null,
        {
            state: {
                collections: {
                    comment: tenComments,
                },
            },
            config: MostPopularFeature.providesConfig,
        },
        [story('Click', [CLICK('Show more responses')])],
    ),
    variant('No comments', {
        state: {
            collections: {
                comment: [],
            },
        },
        config: MostPopularFeature.providesConfig,
    }),
]);

component(
    'AllCommentsScreen',
    AllCommentsScreen,
    {
        state: {
            collections: {
                comment: [
                    { key: '1', from: 'a', text: 'Comment 1', time: 0 },
                    { key: '2', from: 'b', text: 'Comment 2', time: 1 },
                    { key: '3', from: 'c', text: 'Comment 3', time: 2 },
                    { key: '4', from: 'a', text: 'Comment 4', time: 4 },
                    { key: '5', from: 'e', text: 'Comment 5', time: 5 },
                    { key: '6', from: 'f', text: 'Comment 6', time: 6 },
                    { key: '7', from: 'g', text: 'Comment 7', time: 7 },
                    { key: '8', from: 'h', text: 'Comment 8', time: 8 },
                    { key: '9', from: 'i', text: 'Comment 9', time: 9 },
                    { key: '10', from: 'j', text: 'Comment 10', time: 10 },
                ],
                upvote: [
                    { key: 1, from: 'a', comment: '1' },
                    { key: 2, from: 'b', comment: '1' },
                    { key: 3, from: 'c', comment: '1' },
                    { key: 4, from: 'a', comment: '3' },
                    { key: 5, from: 'e', comment: '3' },
                ],
            },
        },
        structureKey: 'question',
        features: ['most-popular', 'upvote'],
    },
    [story('Most recent', [CLICK('ranking-selector'), POPUP(CLICK('Most recent'))])],
);
